function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { cloneElement } from 'react';
import { isElement } from '@mantine/utils';
import { useFocusTrap, useMergedRef } from '@mantine/hooks';
function FocusTrap(param) {
    var children = param.children, _param_active = param.active, active = _param_active === void 0 ? true : _param_active, _param_refProp = param.refProp, refProp = _param_refProp === void 0 ? "ref" : _param_refProp;
    var focusTrapRef = useFocusTrap(active);
    var ref = useMergedRef(focusTrapRef, children == null ? void 0 : children.ref);
    if (!isElement(children)) {
        return children;
    }
    return cloneElement(children, _define_property({}, refProp, ref));
}
FocusTrap.displayName = "@mantine/core/FocusTrap";
export { FocusTrap }; //# sourceMappingURL=FocusTrap.js.map
